import { render, staticRenderFns } from "./extra-druck-vorlagen-render.vue?vue&type=template&id=388ca0c4&lang=pug&"
import script from "./extra-druck-vorlagen-render.vue?vue&type=script&lang=js&"
export * from "./extra-druck-vorlagen-render.vue?vue&type=script&lang=js&"
import style0 from "./extra-druck-vorlagen-render.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports